import { Box, CardContent } from '@mui/material'
import { firstDayHandler } from 'components/shared/processes'
import fileSaver from 'file-saver'

import axAPI from 'httpConfig'
import { LicensesType } from 'models/IUserData'
import moment from 'moment'
import { useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'

import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { ReactComponent as AnalyticsDownloadLogo } from '../../../assets/analytics_download_logo.svg'

import { CardStandart } from 'ui/CardStandart'
import { DateRestriction } from 'ui/DatePickerInput'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'

export const SummaryReport = () => {
	const [color, setColor] = useState(COLORS.secondaryFont)
	const primaryDateState = firstDayHandler()
	const [dateRange, setDateRange] = useState({
		startDate: primaryDateState[0],
		endDate: primaryDateState[1],
	})
	const onChangeCallback = value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}
	const { userData } = useAppSelector(state => state.userReducer)
	const licenseInfo = userData?.company?.licenses?.find(
		el => el.license_codename === LicensesType.FOOD_TABLE,
	)
	const availableDates = {
		firstItem: licenseInfo?.start_dt,
		lastItem: licenseInfo?.until_dt,
	}
	const isAvailableRangeDate =
		dateRange.startDate > licenseInfo?.start_dt &&
		dateRange.endDate < licenseInfo?.until_dt
	const handleExportClick = () => {
		axAPI
			.get(
				`analytics/food-intake/export?start=${dateRange.startDate}&end=${dateRange.endDate}`,
				{ responseType: 'arraybuffer' },
			)
			.then(response => {
				const blob = new Blob([response.data], {
					type: 'application/vnd.ms-excel',
				})
				fileSaver.saveAs(
					blob,
					`Сводный отчет ${moment(dateRange.startDate).format(
						'DD.MM.YYYY',
					)} - ${moment(dateRange.endDate).format('DD.MM.YYYY')}.xlsx`,
				)
			})
	}

	return (
		<CardStandart
			sx={{
				boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
				backgroundColor: 'white',
				borderRadius: '12px',
				cursor: 'pointer',
			}}
		>
			<CardContent sx={{ p: '24px' }}>
				<Box
					display='flex'
					flexDirection='row'
					justifyContent='space-between'
					alignItems='center'
				>
					<TypographyHeader>Сводный отчет</TypographyHeader>
					<Box display='flex' flexDirection='row' gap='24px'>
						<OutlinedButton
							disabled={!isAvailableRangeDate}
							onClick={handleExportClick}
							onMouseOver={() => setColor(COLORS.main)}
							onMouseLeave={() => setColor(COLORS.secondaryFont)}
							sx={{
								width: '128px',
								height: '40px',
								margin: '0px',
								color: color,
								border: `1px solid ${COLORS.secondaryFontOpacity}`,
								textTransform: 'none',
								fontWeight: 600,
								'&:hover': {
									backgroundColor: 'transparent',
									color: color,
									borderColor: COLORS.main,
									boxShadow: 'none',
								},
							}}
							startIcon={
								<AnalyticsDownloadLogo
									onMouseOver={() => setColor(COLORS.main)}
									onMouseLeave={() => setColor(COLORS.secondaryFont)}
									stroke={color}
								/>
							}
						>
							Экспорт
						</OutlinedButton>
						<DateRangePicker
							onChangeUpdateDate={onChangeCallback}
							startDate={dateRange.startDate}
							endDate={dateRange.endDate}
							currentRange={'Сегодня'}
							disabledDates={availableDates}
							restrictionType={DateRestriction.PAST}
						/>
					</Box>
				</Box>
				<Box sx={{ pt: '32px', pl: '2px' }}>
					<TypographySecondary>
						Включает в себя информацию по всем группам по следующим показателям:
						количество голов, расход корма и остатки, сухое вещество,
						потребление сухого вещества.
					</TypographySecondary>
				</Box>
			</CardContent>
		</CardStandart>
	)
}
